module.exports = __webpack_public_path__ + "static/media/22_B.09378cba.png";